import { type InsuranceCorporateIdentity } from "../types";

export function HEKLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M50.3314 249C50.3314 249 37.5406 232.587 36.0241 229.567C10.8666 179.542 225.354 156.025 394 161.878C225.254 161.878 64.3214 193.056 50.3314 249Z"
        fill="white"
      />
      <path
        d="M461.709 262C461.709 262 474.468 278.412 475.981 281.437C501.072 331.456 287.175 354.981 119 349.121C287.275 349.121 447.766 317.949 461.709 262.001"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M188.057 216V248.367H155.831V216H137V293H155.831V260.985H188.057V293H207V216H188.057ZM303 216H322V293H303V216ZM373.912 216H351.783L326 252.338L352.081 293H375L346.845 251.415L373.912 216ZM246.438 259.969V280.601H282V293H228V216H282V228.399H246.438V247.712H277.259V259.969H246.438Z"
        fill="#3F3F3E"
      />
    </svg>
  );
}

export const HEK: InsuranceCorporateIdentity = {
  id: "hek",
  name: "HEK",
  logo: HEKLogo,
  backgroundColor: "#2EACDC",
  textColor: "#FFFFFF",
  wildcard: { or: ["hek", "hanseatische"] },
  type: "statutory",
};
